import { z } from 'zod';
/** A frozen physical cut proposal. Lengths already contain one fitting allowance per cut. */
export const CarpetLayout = z.object({
    source_revision_id: z.string().min(1),
    /** Candidate layouts may be priced in a private draft but cannot be released as reviewed cuts. */
    review_status: z.enum(['provisional', 'reviewed']).optional(),
    roll_width_m: z.number().positive().max(20),
    cuts: z.array(z.object({
        floor: z.string().min(1).max(80), label: z.string().min(1).max(120),
        length_m: z.number().positive().max(1000), allowance_m: z.number().nonnegative().max(2),
        direction: z.string().min(1).max(40), rooms: z.array(z.string().max(120)).max(100).default([]),
    })).min(1).max(100),
    /** Carpet laid on flat floors, including wardrobe run-ins, from the measured assessment. */
    floor_used_m2: z.number().nonnegative().max(100000).nullable().default(null),
    /** Carpet actually allocated to stairs. Null until tread/riser/winder templates are checked. */
    stair_used_m2: z.number().nonnegative().max(100000).nullable().default(null),
    notes: z.string().max(2000).default(''),
}).superRefine((v, ctx) => {
    for (const [i, c] of v.cuts.entries())
        if (c.length_m <= c.allowance_m)
            ctx.addIssue({ code: 'custom', path: ['cuts', i, 'length_m'], message: 'Cut must exceed its one fitting allowance' });
    const directions = new Map();
    for (const c of v.cuts) {
        const prior = directions.get(c.floor);
        if (prior && prior !== c.direction)
            ctx.addIssue({ code: 'custom', path: ['cuts'], message: `${c.floor} has more than one pile direction` });
        directions.set(c.floor, c.direction);
    }
});
const r2 = (n) => Math.round(n * 100) / 100;
export function carpetOrderSummary(layout) {
    const cutLengthM = r2(layout.cuts.reduce((n, c) => n + c.length_m, 0));
    const wholeLm = Math.ceil(cutLengthM - 1e-9);
    const chargeableM2 = r2(wholeLm * layout.roll_width_m);
    const usedM2 = layout.floor_used_m2 === null || layout.stair_used_m2 === null ? null : r2(layout.floor_used_m2 + layout.stair_used_m2);
    return { cutLengthM, wholeLm, chargeableM2, usedM2, wasteM2: usedM2 === null ? null : r2(Math.max(0, chargeableM2 - usedM2)),
        fittingAllowanceM: r2(layout.cuts.reduce((n, c) => n + c.allowance_m, 0)), roundingM: r2(wholeLm - cutLengthM) };
}
//# sourceMappingURL=carpet-layout.js.map